import Image from 'next/image';
import React from 'react';

const ArchitectureDiagramAiSecurityGovernance = () => {
    return (
        <div className="section-py dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="md:col-span-12 text-center">
                        <div className='flex flex-col items-center gap-10'>
                        <h2 className="text-primary" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Security-First AI Implementation Pipeline
                        </h2>
                        <Image
                            src="/img/ai-security/ai-security-architecture-diagram-web.svg"
                            width={1236}
                            height={800}
                            className="img-fluid lg:block md:hidden hidden"
                            alt="Architecture Diagram"
                            loading="lazy"
                        />
                        <Image
                            src="/img/ai-security/ai-security-architecture-diagram-mobile.svg"
                            width={1236}
                            height={800}
                            className="img-fluid lg:hidden md:block block"
                            alt="Architecture Diagram"
                            loading="lazy"
                        />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArchitectureDiagramAiSecurityGovernance;
